export default {
  LK: {
    pageTitle: "Personal cabinet",
    subscription: {
      yourSubs: "Your subscription",
      plan_1: "Free plan",
      plan_2: "Extended plan",
      plan_3: "Individual plan",
      changePlan: "Change tariff",
      activeFor: "Active until",
      nextPayment: "Next payment",
      accessFor: "Access is open until",
    },
    settings: "Settings",
    form: {
      labels: {
        status: "Status",
        spec_med: "Specialization",
        position: "Position",
        university: "University",
      },
    },
    verifyBanner: {
      step1: {
        title: "Verify your account",
        agenda: "Required to access AI-powered study uploading and processing",
        status: "Status",
      },
      step2: {
        title: "Verify your account",
        agenda: "Required to access AI-powered study uploading and processing",
        chooseVerifyWay: "Choose a verification method",
        ways: {
          1: "Diploma, certificate, or professional ID",
          2: "Link to your verified profile on a medical aggregator (ProDoctorov, DocDoc, etc.)",
          3: "Link to your profile on the clinic's website",
          4: "Upload your medical education diploma",
          5: "Upload your medical university student ID",
        },
        selectFile: "Select file",
        sendToCheck: "Submit for verification",
        pasteLink: "Paste the link",
        notAllowedFile: "Only PDF and image formats are allowed.",
        noMoreFiles: "Maximum number of files: ",
      },
      step3: {
        processing: {
          title: "Document sent for review",
          text1_1:
            "Your information is under review. We will verify it shortly and notify you of the status. This usually takes 1 business day.",
        },
        rejected: {
          title: "Account not verified",
          text1_1:
            "Your submission did not pass verification. Please provide valid data. Verification is required to gain access to AI-powered study uploading and processing.",
          text1_2: "Try again",
        },
        accepted: {
          title: "Account verified",
          text1_1:
            "You now have access to upload and process studies using artificial intelligence.",
        },
      },
    },
  },
};
